import React, { Fragment } from 'react';
import Header from './Header';
import Topbar from './Topbar';
import NavBar from './NavBar';
import AurumHeader from './AurumHeader';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

// Routes previewing the Aurum redesign get its header instead of the old chrome.
const aurumPreviewPaths = ['/home-preview'];

export default function Layout() {
  const theme = useTheme();
  const navBarMatches = useMediaQuery(theme.breakpoints.up('md'));
  const { pathname } = useLocation();

  if (aurumPreviewPaths.includes(pathname)) {
    return <AurumHeader />;
  }

  return (
    <Fragment>
      <Topbar />
      <Header />
      <div className="section-after-sticky" style={{ height: navBarMatches ? '30px' : '0px' }}>
        {navBarMatches && <NavBar />}
      </div>
    </Fragment>
  );
}
